import axios from 'axios';
import api from '../axiosConfig';
import { useEffect, useSyncExternalStore } from 'react';

export const SERVICE_LABELS = { map: 'Mapa visual', search: 'Búsqueda de direcciones', reverse: 'Coordenadas a dirección', route: 'Cálculo de rutas', street_view: 'Vista de calle', navigation: 'Navegación externa' };
export const legacyBrowserKey = process.env.REACT_APP_GOOGLE_API_KEY || '';
const defaults = {
  version: 0, services: Object.fromEntries(Object.keys(SERVICE_LABELS).map(key => [key, 'google'])),
  execution: { search: 'browser', reverse: 'browser', route: 'browser' },
  google: { browser_key: legacyBrowserKey, map_id: 'DEMO_MAP_ID' }, language: 'es', country: 'co',
};
export const publicGeoApi = axios.create({ baseURL: api.defaults.baseURL, timeout: 12000 });
let snapshot = { config: defaults, ready: false, error: null, reloadRequired: false };
let pending;
let lastFetch = 0;
let loadedSignature;
const listeners = new Set();
const notify = () => listeners.forEach(fn => fn());
export const browserSignature = config => JSON.stringify([config.services.map, config.google.browser_key, config.google.map_id, config.language, config.country]);
export const markMapLoaded = config => { loadedSignature = browserSignature(config); };
export const currentGeoConfig = () => snapshot.config;
export async function refreshGeoConfig(force = false) {
  if (pending) return pending;
  if (!force && snapshot.ready && Date.now() - lastFetch < 60000) return snapshot.config;
  pending = publicGeoApi.get('/geo-web/config').then(({ data }) => {
    const received = data.data;
    const config = { ...defaults, ...received, google: { ...defaults.google, ...received.google,
      browser_key: received.google?.browser_key || (received.version === 0 ? legacyBrowserKey : '') } };
    snapshot = { config, ready: true, error: null, reloadRequired: !!loadedSignature && loadedSignature !== browserSignature(config) };
    return config;
  }).catch(() => {
    snapshot = { ...snapshot, ready: true, error: 'No se pudo actualizar la configuración geográfica. Se conserva la última configuración disponible.' };
    return snapshot.config;
  }).finally(() => { pending = null; lastFetch = Date.now(); notify(); });
  return pending;
}
const subscribe = fn => { listeners.add(fn); return () => listeners.delete(fn); };
export function useGeoConfig() {
  const value = useSyncExternalStore(subscribe, () => snapshot);
  useEffect(() => { refreshGeoConfig(); }, []);
  return value;
}
